import { render } from "./ResponsiveMenu.vue?vue&type=template&id=01f0d912"
import script from "./ResponsiveMenu.vue?vue&type=script&lang=js"
export * from "./ResponsiveMenu.vue?vue&type=script&lang=js"

import "./ResponsiveMenu.vue?vue&type=style&index=0&id=01f0d912&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__